module.exports = __webpack_public_path__ + "static/sm-90073202dcaa0aa583e965a4610a079f.svg";